import { Typography } from "@mui/material";
import React, { Component, ReactNode } from "react";

class ChartsErrorBoundary extends Component<
  { children: ReactNode },
  { hasError: boolean }
> {
  constructor(props: any) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <Typography variant="subtitle1" color="red" marginTop={3}>
          ⚠️ Chart failed to load. Please try another request.
        </Typography>
      );
    }
    return this.props.children;
  }
}

export default ChartsErrorBoundary;
